import useEncryption from "./useEncryption";

function useAuthFetch() {

    const { encrypt, decrypt } = useEncryption()

    const customFetch = async (url, method, headers, bodyContent) => {
        try {
            const encryptedRequest = await encrypt(bodyContent)
            const options = {
                method,
                headers,
                body: JSON.stringify({
                    encryptedRequest
                })
            }
            const fetchResponse = await fetch(url, options);
            const responseJSON = await fetchResponse.json()
            const response = await decrypt(responseJSON?.encryptedResponse)

            return { response, status: fetchResponse.status, message: responseJSON?.message };
        } catch (error) {
            console.error("=== ERROR IN USEAUTHFETCH ===");
            console.error("Error details:", error);
            console.error("Error message:", error?.message);
            console.error("Error stack:", error?.stack);
            console.error("=== END ERROR ===");
            throw error;
        }
    };

    return customFetch;
}

export default useAuthFetch;
